<app-loader [isLoading]="isLoading"></app-loader>
<div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
</div>

<div class="content">
  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Mes</mat-label>
      <mat-select [(value)]="selectedMonth" (selectionChange)="onMonthYearChange()">
        <mat-option value="1">Enero</mat-option>
        <mat-option value="2">Febrero</mat-option>
        <mat-option value="3">Marzo</mat-option>
        <mat-option value="4">Abril</mat-option>
        <mat-option value="5">Mayo</mat-option>
        <mat-option value="6">Junio</mat-option>
        <mat-option value="7">Julio</mat-option>
        <mat-option value="8">Agosto</mat-option>
        <mat-option value="9">Septiembre</mat-option>
        <mat-option value="10">Octubre</mat-option>
        <mat-option value="11">Noviembre</mat-option>
        <mat-option value="12">Diciembre</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Año</mat-label>
      <mat-select [(value)]="selectedYear" (selectionChange)="onMonthYearChange()">
        @for (year of availableYears; track year) {
        <mat-option [value]="year.toString()">{{ year }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <mat-tab-group mat-stretch-tabs>
    <mat-tab label="Procesar">
      <div class="check-files-buttons">
        <button id="action" mat-button (click)="processNomines('serveto_svt')" [disabled]="
            isCompanyProcessing('serveto_svt') ||
            isCompanyProcessing('serveto_xofers_lux') ||
            isCompanyProcessing('serveto_gestio_lux') ||
            isCompanyProcessing('serveto_sas')
          ">
          {{
          isCompanyProcessing("serveto_svt")
          ? "Procesando Serveto..."
          : "Procesar Serveto"
          }}
        </button>
        <button id="action" mat-button (click)="processNomines('serveto_xofers_lux')" [disabled]="
            isCompanyProcessing('serveto_xofers_lux') ||
            isCompanyProcessing('serveto_gestio_lux') ||
            isCompanyProcessing('serveto_svt') ||
            isCompanyProcessing('serveto_sas')
          ">
          {{
          isCompanyProcessing("serveto_xofers_lux")
          ? "Procesando Xofers Lux..."
          : "Procesar Xofers Lux"
          }}
        </button>
        <button id="action" mat-button (click)="processNomines('serveto_gestio_lux')" [disabled]="
            isCompanyProcessing('serveto_xofers_lux') ||
            isCompanyProcessing('serveto_gestio_lux') ||
            isCompanyProcessing('serveto_svt') ||
            isCompanyProcessing('serveto_sas')
          ">
          {{
          isCompanyProcessing("serveto_gestio_lux")
          ? "Procesando Gestió Lux..."
          : "Procesar Gestió Lux"
          }}
        </button>
        <button id="action" mat-button (click)="processNomines('serveto_sas')" [disabled]="
            isCompanyProcessing('serveto_xofers_lux') ||
            isCompanyProcessing('serveto_gestio_lux') ||
            isCompanyProcessing('serveto_svt') ||
            isCompanyProcessing('serveto_sas')
          ">
          {{
          isCompanyProcessing("serveto_sas")
          ? "Procesando SAS..."
          : "Procesar SAS"
          }}
        </button>
        <button class="cancel" mat-button (click)="cancelPayroll()">
          Cancelar Nóminas
        </button>
      </div>

      <div class="latest-processes-section">
        <h3>Últimos Procesos (actualización cada 5 segundos)</h3>
        <div class="latest-process-result">
          @if (latestProcessesData) {
          <div class="results">
            <pre>{{ latestProcessesData | json }}</pre>
          </div>
          } @else {
          <div class="no-data">Cargando datos...</div>
          }
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Estado">
      <div class="tab-content">
        <div class="section-header">
          <div class="left-side">
            <mat-form-field appearance="outline" id="company-filter">
              <mat-label>Compañía</mat-label>
              <mat-select [(value)]="selectedCompany" (selectionChange)="onFiltersChange()">
                <mat-option value="">Todas</mat-option>
                <mat-option value="serveto_svt">Serveto SVT</mat-option>
                <mat-option value="serveto_xofers_lux">Serveto Xofers LUX</mat-option>
                <mat-option value="serveto_gestio_lux">Serveto Gestió LUX</mat-option>
                <mat-option value="serveto_sas">Serveto SAS</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" id="search-tab">
              <mat-label id="search">Trabajador</mat-label>
              <mat-icon matTextPrefix style="position: relative; top: +0.33em">search</mat-icon>
              <input matInput type="search" [(ngModel)]="searchTerm" (input)="onFiltersChange()"
                placeholder="Buscar por nombre o ID..." />
            </mat-form-field>
          </div>
          <div class="right-buttons">
            <button id="action" mat-button (click)="getEmployeePayroll()">
              <mat-icon>refresh</mat-icon>
              Actualizar
            </button>
            <button id="action" mat-button (click)="validateAll()">Validar Todos</button>
            <button id="action" mat-button (click)="unvalidateAll()">Invalidar Todos</button>
          </div>
        </div>

        @if (employeePayrollData.length > 0) {
        <div class="table-container">
          <table mat-table [dataSource]="employeePayrollDataSource" matSort class="mat-elevation-z8">

            <!-- User Column -->
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>TRABAJADOR</th>
              <td mat-cell *matCellDef="let element">{{ element.personnel_number | qeqPipe }}</td>
            </ng-container>

            <!-- Personnel Number Column -->
            <ng-container matColumnDef="personnel_number">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ID EMPLEADO</th>
              <td mat-cell *matCellDef="let element">{{ element.personnel_number }}</td>
            </ng-container>
            <!-- Company Column -->
            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>COMPAÑÍA
              </th>
              <td mat-cell *matCellDef="let element">{{ element.company }}</td>
            </ng-container>

            <!-- NRO Column -->
            <ng-container matColumnDef="nro">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>NRO</th>
              <td mat-cell *matCellDef="let element">{{ element.nro }}</td>
            </ng-container>

            <!-- Year Column -->
            <ng-container matColumnDef="year">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>AÑO</th>
              <td mat-cell *matCellDef="let element">{{ element.year }}</td>
            </ng-container>

            <!-- Month Column -->
            <ng-container matColumnDef="month">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>MES</th>
              <td mat-cell *matCellDef="let element">{{ getMonthName(element.month.toString()) }}</td>
            </ng-container>

            <!-- Total Pages Column -->
            <ng-container matColumnDef="total_pages">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nº PÁGINAS</th>
              <td mat-cell *matCellDef="let element">{{ element.total_pages }}</td>
            </ng-container>

            <!-- Validated Status Column -->
            <ng-container matColumnDef="validated">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ESTADO</th>
              <td mat-cell *matCellDef="let element">
                <span class="validation-status" [class.validated]="element.validated"
                  [class.not-validated]="!element.validated">
                  {{ element.validated ? 'Validado' : 'Pendiente' }}
                </span>
              </td>
            </ng-container>

            <!-- Validate Checkbox Column -->
            <ng-container matColumnDef="validate">
              <th mat-header-cell *matHeaderCellDef>VALIDAR</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle [checked]="element.validated" [disabled]="isValidationUpdating(element.id)"
                  (change)="onValidationChange(element, $event)">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="employeePayrollDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: employeePayrollDisplayedColumns;"></tr>
          </table>
        </div>
        } @else {
        <div class="no-data">
          <p>No hay datos de nóminas de empleados para mostrar.</p>
        </div>
        }

      </div>
    </mat-tab>

  </mat-tab-group>
</div>